import React from "react";
import PrinterFilesPage from "./PrinterFilesPage";
import usePrinterFiles from "./usePrinterFiles";

function PrinterFiles() {
  return <PrinterFilesPage {...usePrinterFiles()} />;
}

export default PrinterFiles;
